import HTTP from '@/api';

export default (store) => {
  const loading = {
    increment(config) {
      if (config.url.includes('attachedfile')) {
        store.commit('loading/handle', config);
      } else {
        store.commit('loading/add', config);
      }
    },
    decrement(config) {
      setTimeout(() => {
        if (config.url.includes('attachedfile')) {
          store.commit('loading/unhandle', config);
        } else {
          store.commit('loading/remove', config);
        }
      }, 50);
    },
  };

  HTTP.interceptors.request.use(
    (config) => {
      loading.increment(config);
      return config;
    },
    (error) => {
      loading.decrement(error.config);
      return Promise.reject(error);
    },
  );

  HTTP.interceptors.response.use(
    (response) => {
      loading.decrement(response.config);
      return response;
    },
    (error) => {
      loading.decrement(error.config);
      return Promise.reject(error);
    },
  );
};
